import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';

import { useNavigationOptions } from 'app/hooks/navigation';
import type { SpecificNavigationProp } from 'app/types/navigation';
import { useUISize } from 'app/utils/web-helpers';
import type { TFunction } from 'i18next';
import { Pressable } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconArrowLeft, IconChevronLeft, IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

export function useRatingModalNavigationOptions(
  navigation: SpecificNavigationProp<'new-rating' | 'update-rating'>,
  {
    isCommentStep,
    setIsCommentStep,
    t,
  }: { isCommentStep: boolean; setIsCommentStep: (value: boolean) => void; t: TFunction<'ratings'> },
) {
  const { isLargeUI } = useUISize();

  const options = (() => {
    const handleBack = () => {
      if (isCommentStep) {
        setIsCommentStep(false);
      } else {
        navigation.goBack();
      }
    };

    const headerButtonColor = theme.colors['white-label.header.on-header'];
    const stepCount = isCommentStep ? 2 : 1;

    return {
      headerBackVisible: false,
      headerLeft: () =>
        isLargeUI ? (
          <Button onPress={handleBack}>
            {isCommentStep ? (
              <IconChevronLeft strokeWidth={ICON_STROKE_WIDTH} color={headerButtonColor} />
            ) : (
              <IconX strokeWidth={ICON_STROKE_WIDTH} color={headerButtonColor} />
            )}
          </Button>
        ) : (
          <Pressable hitSlop={6} onPress={handleBack}>
            {isCommentStep ? (
              <IconArrowLeft strokeWidth={ICON_STROKE_WIDTH} color={headerButtonColor} />
            ) : (
              <IconX strokeWidth={ICON_STROKE_WIDTH} color={headerButtonColor} />
            )}
          </Pressable>
        ),
      headerTitle: () =>
        isLargeUI ? (
          <Column alignItems="flex-start" gap="spacing.general.x0,5">
            <Text color="white-label.header.on-header" variant="bodyXLargeMedium">
              {t('newRating.figmaHeaderTitle')}
            </Text>
            <Text color="white-label.header.on-header" fontSize={13} fontWeight="500">
              {t('newRating.figmaStepLabel', { count: stepCount })}
            </Text>
          </Column>
        ) : (
          <Column alignItems="center" gap="spacing.general.x0,5">
            <Text color="white-label.header.on-header" fontSize={17} fontWeight="700">
              {t('newRating.figmaHeaderTitle')}
            </Text>
            <Text color="white-label.header.on-header" fontSize={13} fontWeight="500">
              {t('newRating.figmaStepLabel', { count: stepCount })}
            </Text>
          </Column>
        ),
    };
  })();

  useNavigationOptions(navigation, options);
}
